import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { Link, type LinkProps } from 'react-router';

import { cn } from '@/lib/utils';
import { buttonVariants } from './Button'; // reuse same variants

type ButtonLinkProps = LinkProps &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
    className?: string;
    disabled?: boolean;
  };

const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  (
    { className, variant, size, asChild = false, disabled = false, ...props },
    ref,
  ) => {
    const Comp = asChild ? Slot : Link;

    // If disabled, remove navigation-related props and apply aria-disabled
    const componentProps = {
      ...props,
      ...(disabled && {
        onClick: (e: React.MouseEvent) => e.preventDefault(),
        tabIndex: -1,
        'aria-disabled': true,
      }),
    };

    return (
      <Comp
        ref={ref}
        className={cn(
          buttonVariants({ variant, size }),
          disabled && 'pointer-events-none opacity-50',
          className,
        )}
        {...componentProps}
      />
    );
  },
);

ButtonLink.displayName = 'ButtonLink';

export { ButtonLink };
